import React, { useEffect, useState } from 'react';

type LoadingBarProps = {
  speed?: 'slow' | 'medium' | 'fast';
};

const LoadingBar: React.FC<LoadingBarProps> = ({ speed = 'fast' }) => {
  const [width, setWidth] = useState(5);

  const getInterval = () => {
    switch (speed) {
      case 'slow':
        return 300;
      case 'medium':
        return 200;
      case 'fast':
      default:
        return 100;
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      // No side effects inside the state updater — capping at 100 is enough;
      // the effect cleanup clears the interval.
      setWidth((prevWidth) => Math.min(prevWidth + 5, 100));
    }, getInterval());

    return () => clearInterval(interval);
  }, [speed]);

  const durationClass = speed === 'slow' ? 'duration-300' :
                       speed === 'medium' ? 'duration-200' : 
                       'duration-100';

  return (
    <div
      className="fixed top-0 left-0 z-50 w-full h-1"
      role="progressbar"
      aria-label="Page loading"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={width}
    >
      <div
        style={{ width: `${width}%` }}
        className={`h-full bg-primary transition-[width] ease-linear ${durationClass} animate-pulse`}
      ></div>
    </div>
  );
};

export { LoadingBar };
export default LoadingBar;
